import Vue from "vue";
import { createPinia, PiniaVuePlugin } from "pinia";
import Router from "vue-router";
import router from "../router";
import vuetify from "../plugins/vuetify";
import App from "../App.vue";
import { VTextField } from "vuetify/lib";
import "../stylesheets/ncaa.scss";
import VueMask from "v-mask";
Vue.use(VueMask);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
Vue.use(Router);
// Globally import VTextField
Vue.component("v-text-field", VTextField);
Vue.prototype.clipboard = navigator.clipboard;
export default new Vue({
  router,
  vuetify,
  pinia,
  render: (h) => h(App),
});
